module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-support-box-image-b43b7a8c9cc90f23495586272ccf93e4.jpg";